module.exports = __webpack_public_path__ + "img/git.f3484fc0.png";